import { useContext } from "react"

import { CitationPreviewContext } from "./citation-preview-shared"

export function useCitationPreview() {
  const context = useContext(CitationPreviewContext)
  if (!context) {
    throw new Error("useCitationPreview must be used within CitationPreviewProvider")
  }
  return context
}
